var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "event-pic"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-wrappe carousel",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_vm._l(_vm.picDataSource, function (b, i) {
    return _c('swiper-slide', {
      key: i,
      staticClass: "swiper-slide"
    }, [_c('img', {
      attrs: {
        "src": b.cmsCover_url,
        "alt": ""
      },
      on: {
        "click": function click($event) {
          return _vm.toPicDetail(b);
        }
      }
    })]);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.oldEventPic && _vm.oldEventPic.length > 1,
      expression: "oldEventPic && oldEventPic.length > 1"
    }],
    staticClass: "swiper-pagination swiper-pagination-white",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.oldEventPic && _vm.oldEventPic.length > 1,
      expression: "oldEventPic && oldEventPic.length > 1"
    }],
    staticClass: "swiper-button-prev swiper-button-white",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.oldEventPic && _vm.oldEventPic.length > 1,
      expression: "oldEventPic && oldEventPic.length > 1"
    }],
    staticClass: "swiper-button-next swiper-button-white",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2), _c('router-link', {
    staticClass: "see-more",
    attrs: {
      "slot": "tabBarExtraContent",
      "to": {
        path: '/cms/pic'
      }
    },
    slot: "tabBarExtraContent"
  }, [_vm._v("查看更多>>")])], 1), _c('br'), _c('div', {
    staticClass: "event-video"
  }, [_c('br'), _c('a-list', {
    attrs: {
      "grid": {
        gutter: _vm._isMobile() ? 12 : 24,
        lg: 4,
        md: 4,
        sm: 2,
        xs: 2
      },
      "dataSource": _vm.videoDataSource
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {
          staticClass: "animate__animated animate__fadeIn"
        }, [_c('div', {
          staticClass: "img-zoom",
          on: {
            "click": function click($event) {
              return _vm.toVideoDetail(item);
            }
          }
        }, [_c('img', {
          staticClass: "cover",
          attrs: {
            "src": item.cmsCover_url,
            "alt": ""
          }
        })])]);
      }
    }])
  }), _c('router-link', {
    staticClass: "see-more",
    attrs: {
      "slot": "tabBarExtraContent",
      "to": {
        path: '/cms/video'
      }
    },
    slot: "tabBarExtraContent"
  }, [_vm._v("查看更多>>")]), _c('br')], 1), _c('a-modal', {
    attrs: {
      "width": 800,
      "visible": _vm.videoVisible,
      "maskClosable": false,
      "title": _vm.currentVideo.cmsTitile,
      "destroyOnClose": true,
      "footer": null
    },
    on: {
      "cancel": function cancel($event) {
        _vm.videoVisible = false;
      }
    }
  }, [_c('video', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls": "",
      "controlsList": "nodownload noremote footbar",
      "oncontextmenu": "return false;",
      "autoplay": "",
      "src": _vm.currentVideo.extraFile_url
    }
  })]), _c('LightBox', {
    ref: "lightbox",
    attrs: {
      "showLightBox": false,
      "showCaption": true,
      "media": _vm.lightBoxMedia
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };